import { Data } from "@angular/router";
import { Model, ModelId } from "../../../../../../../common/rest-api/models/model";
import { DateTime } from "luxon";

export interface IStopCustomer
{
  customerCode: string;
  name: string;
  statusDate: DateTime;
  currBal: number;
  period1: number;
  period2:number;
  period3:number;
  period4:number;
  
}

export class AllStopCustomer extends Model {
    get modelId(): ModelId {
        throw new Error("Method not implemented.");
    }

    customer: IStopCustomer;
}